// extracted by mini-css-extract-plugin
module.exports = {"seeLiveProject12":"CNCCutting-module--seeLiveProject12--hq4tx","sourceCodeProject12":"CNCCutting-module--sourceCodeProject12--3vC4E"};